import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'modal-externo',
  templateUrl: './modal-externo.component.html',
  styleUrls: ['./modal-externo.component.css']
})
export class ModalExternoComponent {
  constructor(public dialogRef: MatDialogRef<ModalExternoComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {
  }
}
